var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 1.89121V5.33332C11.6668 5.80003 11.6668 6.03339 11.7577 6.21165C11.8376 6.36845 11.965 6.49593 12.1218 6.57583C12.3001 6.66666 12.5335 6.66666 13.0002 6.66666H16.4423M16.6668 8.32351V14.3333C16.6668 15.7335 16.6668 16.4335 16.3943 16.9683C16.1547 17.4387 15.7722 17.8212 15.3018 18.0608C14.767 18.3333 14.067 18.3333 12.6668 18.3333H7.3335C5.93336 18.3333 5.2333 18.3333 4.69852 18.0608C4.22811 17.8212 3.84566 17.4387 3.60598 16.9683C3.3335 16.4335 3.3335 15.7335 3.3335 14.3333V5.66666C3.3335 4.26653 3.3335 3.56646 3.60598 3.03168C3.84566 2.56128 4.22811 2.17882 4.69852 1.93914C5.2333 1.66666 5.93336 1.66666 7.3335 1.66666H10.01C10.6215 1.66666 10.9272 1.66666 11.2149 1.73573C11.47 1.79697 11.7139 1.89798 11.9375 2.03506C12.1898 2.18966 12.406 2.40585 12.8384 2.83823L15.4953 5.49508C15.9276 5.92746 16.1438 6.14365 16.2984 6.39594C16.4355 6.61962 16.5365 6.86349 16.5978 7.11858C16.6668 7.4063 16.6668 7.71203 16.6668 8.32351Z",
    stroke: "#F04438",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileError);
export default __webpack_public_path__ + "static/media/file-error.07998d89b3f53e610a8ed8ec681aec49.svg";
export { ForwardRef as ReactComponent };